<script setup lang="ts">
import type { FooterMobileAppSection } from '~/types/footer';

defineProps<{
  data: FooterMobileAppSection;
}>();

const { isDesktop } = useGetDevice();
</script>

<template>
  <div
    class="rounded-3xl-smooth flex w-78 shrink-0 items-center gap-4 bg-white p-6 md:w-[calc(100%-2rem)] md:max-w-85.75 md:flex-col md:gap-6"
  >
    <LazyAppFooterMobileAppSectionDesktopLayout v-if="isDesktop" :data />
    <LazyAppFooterMobileAppSectionMobileLayout v-else :data />
  </div>
</template>
